import * as THREE from 'three'
import { Canvas, useFrame, useThree, } from '@react-three/fiber'
import { Sparkles, Shadow, ContactShadows, Billboard, Environment, BakeShadows, OrbitControls , CubeCamera, useGLTF} from '@react-three/drei'
import { LayerMaterial, Depth } from 'lamina'
import { useEffect, useRef, useState,useLayoutEffect } from 'react'
import testModel from './model/test1.glb'
import testModel1 from './model/porsche-transformed.glb'
import { loadGltf } from '../../functions/LoadGltfHelper'

 const Skill = ({ env = 'https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/evening_road_01_2k.hdr' }) => (
  <Canvas shadows camera={{ position: [0, 0, 12], fov: 30 }}>
    {/* <hemisphereLight intensity={0.5} color="white" groundColor="black" /> */}
    <Environment files={env} ground={{ height: 5, radius: 40, scale: 20 }} />
    {/* <Sphere color="white" amount={50} emissive="green" glow="lightgreen" position={[1, 1, -1]} />
    <Sphere color="white" amount={30} emissive="purple" glow="#ff90f0" size={0.5} position={[-1.5, 0.5, -2]} />
    <Sphere color="lightpink" amount={20} emissive="orange" glow="#ff9f50" size={0.25} position={[-1, 0.25, 1]} /> */}
    <ContactShadows position={[0,20,20]} rotation={[1,0,1]} renderOrder={2} color="black" resolution={1024} frames={1} scale={10} blur={1.5} opacity={0.65} far={0.5} />
    {/* <BakeShadows /> */}
    <OrbitControls autoRotateSpeed={0.85} zoomSpeed={0.75} minPolarAngle={Math.PI / 2.5} maxPolarAngle={Math.PI / 2.55} />
    <MainCharacter position={[-0.4,0,-1]} />
    <Car  position={[0,0,0]}  rotation={[0,2,0]}/>
    <Lights/>
  </Canvas>
)
let mixer;
const clock = new THREE.Clock();
function MainCharacter({ size = 1, amount = 50, color = 'white', emissive, glow, ...props }){
    const { gl, scene } = useThree()
    const ref = useRef()
    useFrame((state) => {
        const delta = clock.getDelta();
        if (mixer)
            mixer.update(delta)
    })

    const [gltf, setGltf] = useState(null)
    useEffect(() => {
        if (gl)
            handleModel()
    }, [gl])
    const handleModel = async () => {
        let model = await loadGltf(testModel, gl)
        mixer = new THREE.AnimationMixer(model.scene);
        mixer.clipAction(model.animations[2]).play();
        setGltf(model)
    }
    return (
        <group ref={ref} dispose={null} {...props}>

            <mesh name='model_loaded' position={props.position} receiveShadow castShadow >
                {gltf && <primitive object={gltf.scene} />}
                <Shadow rotation={[-Math.PI / 2, 0, 0]} scale={size} position={[0,0,0]} color={emissive} opacity={0.9}  />
                {/* <Glow scale={size * 1.2} near={-25} color={glow || emissive || color} /> */}

            </mesh>
        </group>
    )
}
const Lights = () => {
    const lights = useRef()


    return (
        <>
            {/* <directionalLight intensity={0.1} position={[2, 2, 0]} color="#CFE2F3" distance={5} /> */}
            <spotLight intensity={1} position={[-15, 10, 2]} angle={0.2} penumbra={1} castShadow shadow-mapSize={[2048, 2048]} />
            {/* <group ref={lights}>
                <rectAreaLight intensity={2} position={[4.5, 0, -3]} width={10} height={10} onUpdate={(self) => self.lookAt(0, 0, 0)} />
                <rectAreaLight intensity={2} position={[-10, 2, -10]} width={15} height={15} onUpdate={(self) => self.lookAt(0, 0, 0)} />
            </group> */}
        </>
    )
}
const Sphere = ({ size = 1, amount = 50, color = 'white', emissive, glow, ...props }) => (
  <mesh {...props}>
    <sphereGeometry args={[size, 64, 64]} />
    <meshPhysicalMaterial roughness={0} color={color} emissive={emissive || color} envMapIntensity={0.2} />
    <Glow scale={size * 1.2} near={-25} color={glow || emissive || color} />
    <Sparkles count={amount} scale={size * 2} size={6} speed={0.4} />
    <Shadow rotation={[-Math.PI / 2, 0, 0]} scale={size} position={[0, -size, 0]} color={emissive} opacity={0.5} />
  </mesh>
)

const Glow = ({ color, scale = 0.5, near = -2, far = 1.4 }) => (
  <Billboard>
    <mesh>
      <circleGeometry args={[2 * scale, 16]} />
      <LayerMaterial
        transparent
        depthWrite={false}
        blending={THREE.CustomBlending}
        blendEquation={THREE.AddEquation}
        blendSrc={THREE.SrcAlphaFactor}
        blendDst={THREE.DstAlphaFactor}>
        <Depth colorA={color} colorB="black" alpha={1} mode="normal" near={near * scale} far={far * scale} origin={[0, 0, 0]} />
        <Depth colorA={color} colorB="black" alpha={0.5} mode="add" near={-40 * scale} far={far * 1.2 * scale} origin={[0, 0, 0]} />
        <Depth colorA={color} colorB="black" alpha={1} mode="add" near={-15 * scale} far={far * 0.7 * scale} origin={[0, 0, 0]} />
        <Depth colorA={color} colorB="black" alpha={1} mode="add" near={-10 * scale} far={far * 0.68 * scale} origin={[0, 0, 0]} />
      </LayerMaterial>
    </mesh>
  </Billboard>
)

function Car({ ...props }) {
    const group = useRef()
    const { nodes, materials } = useGLTF(testModel1)
  
    useLayoutEffect(() => {
      materials.paint.color.set('#ffdf71')
      materials.paint.metalness = 0.2
      materials.paint.roughness = 0
      materials.paint.clearcoat = 1
      materials.paint.envMapIntensity = 1.5
      materials.paint.aoMapIntensity = 1.5
      materials.paint.roughnessMapIntensity = 2
      materials['930_chromes'].metalness = 1
      materials['930_chromes'].roughness = 0.3
      materials['930_chromes'].color = new THREE.Color('white')
      materials['glass'].color = new THREE.Color('white')
      materials['glass'].opacity = 0.6
      materials['930_plastics'].roughness = 0.8
      materials['930_lights'].emissiveMap = materials['930_lights'].map
      materials['930_lights'].emissiveIntensity = 50
      materials['930_tire'].color.set('black')
      materials['930_tire'].roughness = 0.7
    }, [materials])
  
    return (
      <group ref={group} {...props} dispose={null}>
        <CubeCamera frames={1} position={[0, 1.5, 0]} near={0.1} resolution={128}>
          {(texture) => (
            <group position={[0, -1.5, 0]}>
              <group rotation={[Math.PI / 2, 0, 0]}>
                <mesh
                  geometry={nodes.mesh_1_instance_0.geometry}
                  material={materials['930_plastics']}
                  position={[-7.966238, -0.10155, -7.966238]}
                  scale={0.000973}
                />
                <mesh
                  geometry={nodes.mesh_1_instance_1.geometry}
                  material={materials['930_plastics']}
                  position={[-7.966238, -0.10155, -7.966238]}
                  scale={0.000973}
                />
              </group>
              <group position={[-7.966238, -0.10155, -7.966238]} scale={0.000973}>
                <mesh geometry={nodes.mesh_0.geometry} material={materials.paint} material-envMap={texture} />
                <mesh geometry={nodes.mesh_0_1.geometry} material={materials['930_chromes']} />
                <mesh geometry={nodes.mesh_0_2.geometry} material={materials.black} />
                <mesh geometry={nodes.mesh_0_3.geometry} material={materials['930_lights']} />
                <mesh geometry={nodes.mesh_0_4.geometry} material={materials.glass} />
                <mesh geometry={nodes.mesh_0_5.geometry} material={materials['930_stickers']} />
                <mesh geometry={nodes.mesh_0_6.geometry} material={materials['930_plastics']} material-polygonOffset material-polygonOffsetFactor={-10} />
                <mesh geometry={nodes.mesh_0_7.geometry} material={materials['930_lights_refraction']} />
                <mesh geometry={nodes.mesh_0_8.geometry} material={materials['930_rim']} />
                <mesh geometry={nodes.mesh_0_9.geometry} material={materials['930_tire']} />
              </group>
            </group>
          )}
        </CubeCamera>
        <group position={[-7.966238, -0.10155, -7.966238]} scale={0.000973}>
          <mesh geometry={nodes.mesh_2.geometry} material={materials.plate} material-roughness={1} />
          <mesh geometry={nodes.mesh_2_1.geometry} material={materials.DefaultMaterial} />
          <mesh geometry={nodes.mesh_2_2.geometry} material={materials['Material.001']} material-depthWrite={false} material-opacity={0.6} />
        </group>
      </group>
    )
  }
 export default Skill